import { useState } from 'react'

export default function NewsletterSection() {
  const [email, setEmail] = useState('')
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle')
  const [errorMsg, setErrorMsg] = useState('')

  const formId = 'd96teu5tfb6ioa7s1sf0'
  const formAction = 'http://eocesp.cn/'

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    const form = e.currentTarget
    const formData = new FormData(form)
    const honeypotVal = formData.get('contact_alt')?.toString()?.trim()

    if (honeypotVal) {
      setStatus('success')
      setEmail('')
      setTimeout(() => setStatus('idle'), 3000)
      return
    }

    const emailVal = formData.get('email')?.toString()?.trim()
    if (!emailVal) {
      setErrorMsg('请输入有效的邮箱地址')
      setStatus('error')
      return
    }

    setStatus('submitting')
    setErrorMsg('')

    try {
      const body = new URLSearchParams()
      body.append('email', emailVal)
      body.append('source', 'homepage')

      const response = await fetch(formAction, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      })
      const responseText = await response.text()
      let parsed: Record<string, unknown> = {}
      try { parsed = JSON.parse(responseText) } catch { /* ignore */ }

      if (response.ok && (parsed as { code?: string }).code === 'OK') {
        setStatus('success')
        setEmail('')
      } else {
        const serverMsg = ((parsed as { meta?: { message?: string } })?.meta?.message) || ((parsed as { message?: string })?.message) || responseText
        setErrorMsg(typeof serverMsg === 'string' && serverMsg ? serverMsg : '订阅失败，请稍后再试')
        setStatus('error')
      }
    } catch {
      setErrorMsg('网络错误，请检查连接后重试')
      setStatus('error')
    }
  }

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="max-w-2xl mx-auto text-center">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-primary-100 flex items-center justify-center">
            <i className="ri-mail-send-line text-primary-500 text-2xl"></i>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900 mb-3">
            订阅更新通知
          </h2>
          <p className="text-sm text-foreground-600 mb-8 leading-relaxed">
            第一时间获取最新漫画更新推送，不再错过任何精彩章节。我们承诺不发垃圾邮件，随时可以退订。
          </p>

          <form id={formId} onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <div className="honeypot-field" aria-hidden="true">
              <label htmlFor="contact_alt">备用联系方式</label>
              <input type="text" id="contact_alt" name="contact_alt" tabIndex={-1} autoComplete="off" readOnly />
            </div>
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="输入你的邮箱地址"
              required
              className="flex-1 px-4 py-3 bg-background-100 border border-background-200/70 rounded-full text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-300 transition-colors"
            />
            <button
              type="submit"
              disabled={status === 'submitting'}
              className="px-6 py-3 bg-foreground-900 text-background-50 text-sm font-medium rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap disabled:opacity-60 cursor-pointer"
            >
              {status === 'submitting' ? '订阅中...' : '立即订阅'}
            </button>
          </form>

          {status === 'success' && (
            <p className="mt-4 text-sm text-secondary-600">🎉 订阅成功！感谢你的关注~</p>
          )}
          {status === 'error' && errorMsg && (
            <p className="mt-4 text-sm text-primary-500">{errorMsg}</p>
          )}
        </div>
      </div>
    </section>
  )
}